import {
  FACEBOOK_URL,
  INSTAGRAM_URL,
  LINKEDIN_URL,
  TIKTOK_URL,
} from '@/content/social'
import { SITE_URL } from './site'
import { JsonLd } from './JsonLd'

const schema = {
  '@context': 'https://schema.org',
  '@type': 'ProfessionalService',
  name: 'Elementary Creative',
  url: SITE_URL,
  image: `${SITE_URL}/images/og-default.png`,
  description:
    'Vancouver digital product studio specializing in web design, custom software, POS systems, online booking, CRM, and internal business tools.',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Vancouver',
    addressRegion: 'BC',
    addressCountry: 'CA',
  },
  areaServed: [
    { '@type': 'City', name: 'Vancouver' },
    { '@type': 'AdministrativeArea', name: 'Lower Mainland' },
    { '@type': 'Country', name: 'Canada' },
  ],
  telephone: '+1-639-316-4005',
  sameAs: [INSTAGRAM_URL, FACEBOOK_URL, LINKEDIN_URL, TIKTOK_URL],
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'Digital product services',
    itemListElement: [
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Web design & development',
          url: `${SITE_URL}/services/web-design`,
        },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Custom software (POS, booking, CRM, internal tools)',
          url: `${SITE_URL}/services/custom-software`,
        },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Brand strategy & graphic design',
          url: `${SITE_URL}/services/graphic-design`,
        },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'SEO, performance & UX consulting',
          url: `${SITE_URL}/services`,
        },
      },
    ],
  },
}

export default function LocalBusinessJsonLd() {
  return <JsonLd data={schema} />
}
